import {
    Cell,
    Legend,
    Pie,
    PieChart,
    Tooltip as RechartsTooltip,
    ResponsiveContainer
  } from "recharts";
  import { colors } from "./theme";
  
  interface PieChartComponentProps {
    data: Array<{
      name: string;
      value: number;
      color: string;
    }>;
    innerRadius?: number;
    outerRadius?: number;
  }
  
  export const PieChartComponent = ({
    data,
    innerRadius = 0,
    outerRadius = 80
  }: PieChartComponentProps) => (
    <ResponsiveContainer width="100%" height={200}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          fill="#8884d8"
          paddingAngle={2}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <RechartsTooltip
          contentStyle={{
            backgroundColor: "#fff",
            borderColor: colors.neutral2,
            borderRadius: "4px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
          }}
        />
        <Legend
          layout="vertical"
          align="right"
          verticalAlign="middle"
          iconType="circle"
          formatter={(value) => (
            <span style={{ color: colors.primary }}>{value}</span>
          )}
        />
      </PieChart>
    </ResponsiveContainer>
  );